/* eslint-disable
    import/no-unresolved,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./clientOverviewForm.scss');

const deps = [
  require('angular-ui-router'),
  require('data/user').name,
  require('data/collection/currency').name,
  require('data/collection/ledger').name,
  require('data/collection/addon').name,
  require('data/collection/ledgerCategory').name,
  require('ui/web/cwaForm/toggle').name,
  require('ui/web/notifications').name,
  require('ui/web/confirmDialog').name,
  'ui.select',
];

module.exports = angular
  .module('bench.ui.clientOverview.form', deps)

  .directive('blClientOverviewForm', () => ({
    restrict: 'E',
    scope: {
      ledger: '=?',
      addOn: '=?',
    },
    bindToController: true,
    template: require('./clientOverviewForm.html'),
    controller: require('./clientOverviewFormCtrl.js'),
    controllerAs: 'vm',
  }));
